import { GET_PAYOUTS_REPORT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    payout_sheet_url: string;
}

export default (month: string, year: string, isForDoctor?: boolean): Promise<Response> => {
    return fetchWithRefresh(GET_PAYOUTS_REPORT(month, year, isForDoctor)).then((res) => res.json());
};
